import { get, post } from '../libs/Axios';
import { DataLayerUtils } from '../utilities/DataLayer';
import BaseComponent from '../abstracts/BaseComponent';

export default class AddToCartComponent extends BaseComponent {
  get Messages() {
    return {
      [this.CUSTOM_MESSAGES.ADDTOCART_EVENTS.waitForMe]: this.setDependency,
      [this.CUSTOM_MESSAGES.SELECT_SIZE_EVENTS.selected]: this.setSize,
      [this.CUSTOM_MESSAGES.RENT_CALENDAR_EVENTS.rangeSetted]: this.setRange,
      [this.CUSTOM_MESSAGES.RENT_DURATION_EVENTS.changed]: this.setDuration
    };
  }

  get SELECTORS() {
    return {};
  }

  constructor(element) {
    super(element);
    this.dep = [];
    this.duration = '4';
    this.handleClick();
  }

  removeDependency({ component }) {
    this.dep = this.dep.filter(el => el !== component);
  }

  setDependency({ component }) {
    if (this.dep.indexOf(component) === -1) this.dep.push(component);
  }

  setSize({ sizeSelected, component, product }) {
    if (sizeSelected) {
      this.dep = this.dep.filter(el => el !== component);
      this.size = sizeSelected;
      this.$el.setAttribute('data-option-size', sizeSelected);
    }
  }

  setRange({ duration, startDate, component }) {
    if (duration) {
      this.duration = duration;
      this.$el.setAttribute('data-option-duration', duration);
    }
    if (startDate) this.startDate = startDate;
    this.dep = this.dep.filter(el => el !== component);

    if (startDate) {
      DataLayerUtils.push({
        gaHitType: 'event',
        event: 'popup_interactions',
        eventCategory: 'popup',
        eventAction: 'apply',
        eventLabel: 'on'
      });
    } else {
      DataLayerUtils.push({
        gaHitType: 'event',
        event: 'popup_interactions',
        eventCategory: 'popup',
        eventAction: 'apply',
        eventLabel: 'off'
      });
    }
  }

  setDuration({ value }) {
    this.duration = value;
  }

  async addToCart() {
    const pid = `${this.$options.master}_${this.$el.dataset.optionColor}_${this.$options.size}_${this.duration}`;

    const { data } = await post(this.$options.endpoint, {
      pid,
      quantity: 1,
      options: [],
      rentalStartDate: this.startDate
    });

    if (!data.error) {
      var rentalStartDate;
      data.cart.items.forEach((item) => {
        rentalStartDate = item.rentalStartDate;
      });

      const currentDate = new Date();
      const currentStartDate = new Date(rentalStartDate);
      const daysFromToday = Math.floor((currentStartDate - currentDate) / (1000 * 60 * 60 * 24)) + 1;

      DataLayerUtils.push({
        where: 'from_pdp',
        event: 'addToCart',
        ecommerce: {
          add: {
            products: [
              {
                name: (this.$options.name) ? this.$options.name : '',
                id: (this.$options.master) ? this.$options.master : '',
                price: (this.$options.price) ? this.$options.price : null,
                brand: 'pdb',
                category: (this.$options.category) ? this.$options.category : '',
                variant: (this.$options.variant) ? this.$options.variant : '',
                quantity: (this.$options.quantity) ? this.$options.quantity : null,
                dimension14: (this.$options.store) ? this.$options.store : null,
                dimension15: (this.$options.sales) ? this.$options.sales : '',
                dimension16: (this.$options.availability) ? this.$options.availability : '',
                dimension17: (this.$options.sizepercentage) ? this.$options.sizepercentage : null,
                dimension18: (this.$options.discount) ? this.$options.discount : null,
                dimension19: (this.$options.perfectfor) ? this.$options.perfectfor : '',
                dimension20: (this.duration) ? this.duration : null,
                dimension21: (daysFromToday.toString() || null),
                dimension22: (this.size) ? this.size : '',
              }
            ]
          }
        }
      });
    }

    return data;
  }

  errorMessages() {
    this.dep.forEach((component) => {
      this.EMIT(this.CUSTOM_MESSAGES.ADDTOCART_EVENTS.erros, {
        component
      });
    });

    return false;
  }

  canAdd() {
    return this.dep.length === 0 || this.errorMessages();
  }

  handleClick() {
    this.$on('click.add', async (e) => {
      if (!this.canAdd()) return;
      const button = e.currentTarget;
      this.loading(button);
      try {
        const { error, message } = await this.addToCart();
        if (error) {
          this.endLoading(button, message, true);
          DataLayerUtils.push({
            gaHitType: 'event',
            event: 'pdp_interactions',
            eventCategory: 'pdp',
            eventAction: 'click',
            eventLabel: 'item_already_in_cart'
          });
        } else {
          this.EMIT(this.CUSTOM_MESSAGES.ADDTOCART_EVENTS.itemAdded);
          this.endLoading(button, message);
        }
      } catch (error) {
        this.endLoading(button);
      }
    });
  }
}
